module.exports = __webpack_public_path__ + "static/media/bonusSpins_50_75.43650cea.png";